import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router'

import { Avatar, Col, Divider, Flex, Row, theme, Typography } from 'antd'

import { Icon } from '../../components/icon/Icon'
import { HTML } from '../../components/markup/HTML'
import { Page } from '../../components/page'
import { Title } from '../../components/text/Title'
import { useAboutQuery } from '../../graphql'
import { Context } from '../../providers/Seo'

const About: FC = () => {
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()
  const { socials } = useContext(Context)
  const { data, loading } = useAboutQuery()
  const datum = data?.about

  return (
    <Page loading={loading} title={formatMessage({ id: 'about.header' })}>
      <HTML>{datum?.text}</HTML>
      <Divider />
      <Title level={3}>{formatMessage({ id: 'about.authors' })}</Title>
      <Row justify={'space-around'} gutter={[16, 16]}>
        {datum?.authors?.map((it) => (
          <Col key={it?.title} xs={24} lg={12}>
            <Flex justify={'center'} align={'center'} vertical gap={16} style={{ textAlign: 'center' }}>
              <Avatar shape={'circle'} size={360} src={it?.cover?.url} />
              <Title level={4} style={{ marginBottom: 0 }}>
                {it?.title}
              </Title>
              <Typography.Text strong style={{ fontSize: token.fontSizeLG }}>
                {it?.description}
              </Typography.Text>
            </Flex>
          </Col>
        ))}
      </Row>
      <Divider />

      <Title level={3}>{formatMessage({ id: 'about.friends' })}</Title>
      <Row justify={'space-around'} gutter={[16, 32]}>
        {datum?.friends?.map((it) => (
          <Col key={it?.title} xs={24} lg={8}>
            <Flex justify={'center'} align={'center'} vertical gap={16} style={{ textAlign: 'center' }}>
              <img alt={it?.title ?? ''} width={'unset'} height={120} src={it?.cover?.url} style={{ padding: 16 }} />
              <Title level={4} style={{ marginBottom: 0 }}>
                {it?.url ? (
                  <Link target={'_blank'} rel={'nofollow noreferrer'} to={it?.url}>
                    {it?.title}
                  </Link>
                ) : (
                  it?.title
                )}
              </Title>
              <Typography.Paragraph ellipsis={{ rows: 2 }}>{it?.description}</Typography.Paragraph>
            </Flex>
          </Col>
        ))}
      </Row>
      <Divider />
      <Flex vertical gap={16}>
        <Title level={3}>{formatMessage({ id: 'about.headings.socials' })}</Title>
        <Flex gap={16}>
          {socials?.map(
            (it) =>
              it && (
                <Flex gap={8} key={it.id} align={'center'}>
                  <Link style={{ fontSize: token.fontSizeLG }} to={it?.url}>
                    <Icon type={it.type} style={{ fontSize: 24 }} />
                  </Link>
                </Flex>
              ),
          )}
        </Flex>
      </Flex>
    </Page>
  )
}

export { About as default }
